"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuGenerator = void 0;
var menu_constants_1 = require("./menu-constants");
var menu_constants_2 = require("./menu-constants");
var menu_constants_3 = require("./menu-constants");
var menu_constants_4 = require("./menu-constants");
var menu_constants_5 = require("./menu-constants");
var menu_constants_6 = require("./menu-constants");
var menu_constants_7 = require("./menu-constants");
var menu_constants_8 = require("./menu-constants");
var menu_constants_9 = require("./menu-constants");
var sanitizer_1 = require("../../../common/sanitizer/sanitizer");
var BcMenuGenerator = (function () {
    function BcMenuGenerator() {
        this.sanitizer = new sanitizer_1.BcHTMLSanitizer();
        this.initMenu();
    }
    BcMenuGenerator.prototype.initMenu = function () {
        this.menu = document.createElement('div');
        this.menu.classList.add(menu_constants_1.BC_MENU);
    };
    BcMenuGenerator.prototype.generate = function (configuration) {
        this.configuration = configuration;
        this.generateItems();
        this.generateMainContent();
        return this.menu;
    };
    BcMenuGenerator.prototype.generateItems = function () {
        if (this.configuration.items) {
            var drawer = document.createElement('ul');
            drawer.classList.add(menu_constants_2.BC_MENU_DRAWER);
            for (var _i = 0, _a = this.configuration.items; _i < _a.length; _i++) {
                var item = _a[_i];
                var itemElement = this.generateItem(item);
                drawer.appendChild(itemElement);
            }
            this.generateButton(drawer);
            this.menu.appendChild(drawer);
        }
    };
    BcMenuGenerator.prototype.generateButton = function (drawer) {
        var _this = this;
        if (this.configuration.closeOptions) {
            var liButtonElement = document.createElement('li');
            liButtonElement.classList.add(menu_constants_9.BC_MENU_FOOTER);
            var buttonElement = document.createElement('button');
            buttonElement.classList.add('bc-btn', 'button-secondary', 'btn-small');
            buttonElement.innerText = this.sanitizer.sanitize(this.configuration.closeOptions.text);
            buttonElement.addEventListener('click', function () {
                _this.configuration.closeOptions.function();
            });
            liButtonElement.appendChild(buttonElement);
            drawer.appendChild(liButtonElement);
        }
    };
    BcMenuGenerator.prototype.generateItem = function (item) {
        var itemElement = document.createElement('a');
        itemElement.classList.add(menu_constants_3.BC_MENU_ITEM);
        itemElement.setAttribute('for', item.identifierContent);
        if (item.path && item.path !== '') {
            itemElement.href = item.path;
        }
        else {
            itemElement.href = '#';
        }
        var liElement = document.createElement('li');
        if (item.iconName) {
            var imgElement = document.createElement('img');
            imgElement.setAttribute('class', 'bc-icon-brand--sm');
            imgElement.src = "/assets/icons/brand/".concat(item.iconName, "_off.svg");
            liElement.appendChild(imgElement);
        }
        var textElement = document.createElement('div');
        textElement.innerText = this.sanitizer.sanitize(item.text);
        liElement.appendChild(textElement);
        itemElement.appendChild(liElement);
        return itemElement;
    };
    BcMenuGenerator.prototype.generateMainContent = function () {
        if (this.configuration.contents) {
            var main = document.createElement('div');
            main.classList.add(menu_constants_4.BC_MENU_MAIN_CONTENT);
            main.appendChild(this.generateHeader());
            this.generateBodies(main);
            this.menu.appendChild(main);
        }
    };
    BcMenuGenerator.prototype.generateBodies = function (main) {
        var bodies = document.createElement('div');
        bodies.classList.add(menu_constants_6.BC_MENU_CONTENT_BODIES);
        for (var _i = 0, _a = this.configuration.contents; _i < _a.length; _i++) {
            var body = _a[_i];
            var content = document.createElement('div');
            content.classList.add(menu_constants_5.BC_MENU_CONTENT_BODY);
            content.id = body.identifierContent;
            this.generateColumns(content, body.columns);
            bodies.appendChild(content);
        }
        main.appendChild(bodies);
    };
    BcMenuGenerator.prototype.generateHeader = function () {
        var header = document.createElement('div');
        header.classList.add(menu_constants_8.BC_MENU_HEADER);
        var title = document.createElement('h5');
        var i = document.createElement('i');
        i.classList.add('bc-icon');
        i.classList.add('bc-sm');
        i.innerText = 'error';
        header.appendChild(title);
        header.appendChild(i);
        return header;
    };
    BcMenuGenerator.prototype.generateColumns = function (content, columns) {
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var columnConfig = columns_1[_i];
            var column = document.createElement('div');
            column.classList.add(menu_constants_7.BC_MENU_COLUMN);
            this.generateSections(column, columnConfig.sections);
            content.appendChild(column);
        }
    };
    BcMenuGenerator.prototype.generateSections = function (column, sections) {
        for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
            var section = sections_1[_i];
            var sectionElement = document.createElement('ul');
            var aTitle = document.createElement('a');
            var liTitle = document.createElement('li');
            var h6Title = document.createElement('h6');
            h6Title.innerText = section.title;
            liTitle.appendChild(h6Title);
            aTitle.appendChild(liTitle);
            sectionElement.appendChild(aTitle);
            for (var _a = 0, _b = section.options; _a < _b.length; _a++) {
                var option = _b[_a];
                var a = document.createElement('a');
                var li = document.createElement('li');
                li.innerText = option.text;
                if (option.path && option.path !== '') {
                    a.href = option.path;
                }
                else {
                    a.href = '#';
                }
                a.appendChild(li);
                sectionElement.appendChild(a);
            }
            column.appendChild(sectionElement);
        }
    };
    return BcMenuGenerator;
}());
exports.BcMenuGenerator = BcMenuGenerator;
